"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOrderPayDto = void 0;
const billing_api_payment_intent_dto_1 = require("../../../billing-api-payment/types/dtos/billing-api-payment-intent.dto");
class BillingApiOrderPayDto extends billing_api_payment_intent_dto_1.BillingApiPaymentIntentAbstractDto {}
exports.BillingApiOrderPayDto = BillingApiOrderPayDto;
